import React, { Component } from "react";
import { Modal, Form, Input, Button, Row, Col } from "antd";
import { strings } from "../../../helpers";

const FormItem = Form.Item;

class AddPaymentModal extends Component {
  componentWillUnmount() {
    // Reset form fields on component unmount to prevent memory leaks
    if (this.props.form) {
      this.props.form.resetFields();
    }
  }

  /**
   * @function handleSubmit
   * @param e
   * @description Handle form submission
   */
  handleSubmit = e => {
    e.preventDefault();
    const { form, onSubmit } = this.props;
    
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const data = {
          razorpay_payment_id: values.razorpay_payment_id.trim(),
          razorpay_order_id: values.razorpay_order_id.trim()
        };
        onSubmit(data);
      }
    });
  };

  /**
   * @function handleCancel
   * @description Handle modal cancel
   */
  handleCancel = () => {
    const { form, onCancel } = this.props;
    form.resetFields();
    onCancel();
  };

  render() {
    const { form, visible, isSubmitting } = this.props;
    const { getFieldDecorator } = form;

    return (
      <Modal
        visible={visible}
        title="Add Payment Details"
        footer={null}
        onCancel={this.handleCancel}
        className="form-type-modal"
      >
        <Form layout="vertical" onSubmit={this.handleSubmit}>
          <FormItem label="Razorpay Payment ID">
            {getFieldDecorator("razorpay_payment_id", {
              rules: [
                {
                  required: true,
                  message: "Please enter Razorpay Payment ID"
                },
                {
                  whitespace: true,
                  message: "Payment ID cannot be empty"
                },
                {
                  pattern: /^pay_[A-Za-z0-9]{14}$/,
                  message: "Invalid Razorpay Payment ID format"
                }
              ]
            })(
              <Input
                placeholder="Enter Razorpay Payment ID"
                maxLength={50}
              />
            )}
          </FormItem>

          <FormItem label="Razorpay Order ID">
            {getFieldDecorator("razorpay_order_id", {
              rules: [
                {
                  required: true,
                  message: "Please enter Razorpay Order ID"
                },
                {
                  whitespace: true,
                  message: "Order ID cannot be empty"
                },
                {
                  pattern: /^order_[A-Za-z0-9]{14}$/,
                  message: "Invalid Razorpay Order ID format"
                }
              ]
            })(
              <Input
                placeholder="Enter Razorpay Order ID"
                maxLength={50}
              />
            )}
          </FormItem>

          <FormItem>
            <Row type="flex" gutter={20}>
              <Col>
                <Button 
                  type="primary" 
                  htmlType="submit" 
                  loading={isSubmitting}
                >
                  Submit
                </Button>
              </Col>
              <Col>
                <Button onClick={this.handleCancel}>
                  Cancel
                </Button>
              </Col>
            </Row>
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

const WrappedAddPaymentModal = Form.create()(AddPaymentModal);
export default WrappedAddPaymentModal;